import styled from '@emotion/styled';

import ButtonList, { ButtonListProps } from '../ButtonList';

const StyledList = styled(ButtonList)<ButtonListProps>(
  {
    display: 'flex',
    position: 'absolute',
    top: '50px',
    width: 'max-content'
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.colors.white
  })
);

export default StyledList;
